(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv2-paulina"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const knapp = event.target.closest('[data-pv2-visa-fler]');
    if (!knapp) return;
    const lista = document.getElementById(knapp.getAttribute('aria-controls'));
    if (!lista) return;
    const oppen = knapp.getAttribute('aria-expanded') === 'true';
    knapp.setAttribute('aria-expanded', String(!oppen));
    lista.toggleAttribute('data-expanded', !oppen);
    knapp.textContent = oppen ? knapp.dataset.textFler : knapp.dataset.textFarre;
  });

  } catch(e) { console.error(e); }
})();
})();
